/**
 * AG floating header: "Sticky on scroll up" controller.
 * Hides the whole header group while scrolling down and shows it on scroll up.
 * The mode comes from [data-ag-sticky], printed by sections/ag-floating-header.liquid
 * for the current page. All visuals live in that section's CSS.
 *
 * Vessel scrolls inside .page-wrapper on desktop (990px and up) and the document
 * on smaller screens, so both are read.
 */
(() => {
  if (window.__agFloatingHeader) return;
  window.__agFloatingHeader = true;

  const HIDDEN = 'ag-floating--hidden';

  const getY = () => {
    const wrapper = document.querySelector('.page-wrapper');
    const doc = document.scrollingElement || document.documentElement;
    return Math.max(wrapper ? wrapper.scrollTop : 0, doc ? doc.scrollTop : 0, window.scrollY || 0, 0);
  };

  const getMode = (header) => {
    const marker = document.querySelector('[data-ag-sticky]');
    let mode = marker ? marker.getAttribute('data-ag-sticky') : 'none';
    // "header" = follow the Header section's own Sticky header setting
    if (mode === 'header') mode = header.getAttribute('sticky') || 'none';
    return mode;
  };

  let lastY = getY();
  let ticking = false;

  const update = () => {
    ticking = false;
    const group = document.getElementById('header-group');
    const header = document.getElementById('header-component');
    if (!group || !header) return;

    const y = getY();
    const mode = getMode(header);
    const isHidden = group.classList.contains(HIDDEN);

    // Distance needed to move the group fully out of view (the transparent header
    // is absolutely positioned, so measure the header itself, not only the group box).
    if (!isHidden) {
      const bottom = Math.max(group.getBoundingClientRect().bottom, header.getBoundingClientRect().bottom);
      group.style.setProperty('--ag-hide-distance', `${Math.ceil(Math.max(bottom, 0)) + 24}px`);
    }

    const menuOpen = header.querySelector('details[open], header-menu[aria-expanded="true"]');
    const threshold = header.offsetHeight + group.offsetHeight + 40;

    if (mode !== 'scroll-up' || menuOpen || y < threshold) {
      group.classList.remove(HIDDEN);
      lastY = y;
      return;
    }

    const delta = y - lastY;
    if (Math.abs(delta) < 6) return;

    group.classList.toggle(HIDDEN, delta > 0);
    lastY = y;
  };

  const schedule = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  // capture: true catches scroll events from .page-wrapper (desktop) and the document (mobile)
  document.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });

  // Theme editor: re-evaluate when the header group sections re-render
  const reset = () => {
    const group = document.getElementById('header-group');
    if (group) group.classList.remove(HIDDEN);
    lastY = getY();
    schedule();
  };
  document.addEventListener('shopify:section:load', reset);
  document.addEventListener('shopify:section:unload', () => setTimeout(reset, 0));

  schedule();
})();
